module.exports = __webpack_public_path__ + "img/benefit.7f92ec67.svg";